import { schema } from 'normalizr';

const accountEmailSchema = new schema.Entity('accountEmails', {}, { idAttribute: 'uuid' });

export default accountEmailSchema;
